import Vue3Toastify, { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Vue3Toastify, {
    autoClose: 1500,
    closeButton: false,
    toastStyle: {
      background: '#000',
      color: '#fff',
      display: 'grid',
      justifyContent: 'center',
      fontSize: '13px',
      borderRadius: '20px',
      width: '90%',
      margin: '0 auto',
      bottom: '0',
      top: '20px',
    },
    position: 'top-center',
    progressStyle: { height: '3px' },
  })

  return {
    provide: { toast },
  }
})
